'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _muiThemeable = require('material-ui/styles/muiThemeable');

var _muiThemeable2 = _interopRequireDefault(_muiThemeable);

var _colors = require('material-ui/styles/colors');

var _materialUi = require('material-ui');

var _close = require('material-ui/svg-icons/navigation/close');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Implementation of the web adjusted notification header as described at https://material.io/guidelines/patterns/notifications.html#notifications-anatomy-of-a-notification.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var NotificationHeaderArea = function (_React$PureComponent) {
    _inherits(NotificationHeaderArea, _React$PureComponent);

    function NotificationHeaderArea() {
        _classCallCheck(this, NotificationHeaderArea);

        return _possibleConstructorReturn(this, (NotificationHeaderArea.__proto__ || Object.getPrototypeOf(NotificationHeaderArea)).apply(this, arguments));
    }

    _createClass(NotificationHeaderArea, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                icon = _props.icon,
                headerLabel = _props.headerLabel,
                timestamp = _props.timestamp,
                secondaryHeaderLabel = _props.secondaryHeaderLabel,
                muiTheme = _props.muiTheme,
                primaryColor = _props.primaryColor,
                onClose = _props.onClose;
            // Since the header relies on dynamic information for styling we create the style object inside the render

            var styles = {
                headerLabel: {
                    color: primaryColor || muiTheme.palette.primary1Color,
                    marginLeft: icon ? 8 : 0
                }
            };
            // Check if the notificaton should have another primary color
            var color = primaryColor || muiTheme.palette.primary1Color;
            // For secondary and meta text tags we use React.Fragment which is part of React
            // since 16.2. These tags are not part of the final DOM, but allow us to
            // return multiple tags from a since statement without cluttering the DOM
            // by using div containers.
            return _react2.default.createElement(
                'div',
                { style: NotificationHeaderArea.STYLES.container },
                _react2.default.createElement(
                    'div',
                    { style: NotificationHeaderArea.STYLES.information },

                    // Check if the icon should be rendered and set color and styles
                    !!icon && _react2.default.cloneElement(icon, { color: color, style: NotificationHeaderArea.STYLES.icon }),
                    _react2.default.createElement(
                        'span',
                        { style: _extends({}, NotificationHeaderArea.STYLES.header, styles.headerLabel) },
                        headerLabel
                    ),

                    // Check if the secondary header should be rendered and add a separator if it 
                    // should be rendered
                    !!secondaryHeaderLabel && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'span',
                            { style: NotificationHeaderArea.STYLES.separator },
                            '\xB7'
                        ),
                        _react2.default.createElement(
                            'span',
                            { style: NotificationHeaderArea.STYLES.secondary },
                            secondaryHeaderLabel
                        )
                    ),

                    // Same as for the secondary header
                    !!timestamp && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'span',
                            { style: NotificationHeaderArea.STYLES.separator },
                            '\xB7'
                        ),
                        _react2.default.createElement(
                            'span',
                            { style: NotificationHeaderArea.STYLES.timestamp },
                            timestamp
                        )
                    )
                ),
                _react2.default.createElement(
                    _materialUi.IconButton,
                    {
                        onClick: onClose,
                        iconStyle: NotificationHeaderArea.STYLES.closeButtonIcon,
                        style: NotificationHeaderArea.STYLES.closeButton
                    },
                    _react2.default.createElement(_close2.default, { color: color })
                )
            );
        }
    }]);

    return NotificationHeaderArea;
}(_react2.default.PureComponent);

NotificationHeaderArea.propTypes = {
    /* The title of the application/notification */
    headerLabel: _propTypes2.default.string.isRequired,

    /* Function which is called when the close icon button is clicked */
    onClose: _propTypes2.default.func.isRequired,

    /**
     * Icon shown on the left of the header. May be used to deliver unique 
     * experiences with notificaitons for the user
     */
    icon: _propTypes2.default.node,

    /* A timestamp which is rendered as a secondary text besides the header */
    timestamp: _propTypes2.default.string,

    /* A secondary text which can be used to indicate additional meta information */
    secondaryHeaderLabel: _propTypes2.default.string,

    /* By default notifications use the primary1color defined for the material-ui theme for the header and actions */
    primaryColor: _propTypes2.default.string
};
NotificationHeaderArea.defaultProps = {
    icon: null,
    primaryColor: '',
    secondaryHeaderLabel: '',
    timestamp: ''
};
NotificationHeaderArea.STYLES = {
    closeButton: {
        width: 22,
        height: 22,
        padding: 2
    },
    closeButtonIcon: {
        width: 18,
        height: 18
    },
    container: {
        padding: '16px 16px 0 16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    icon: {
        width: 18,
        height: 18
    },
    information: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    header: {
        fontSize: 14
    },
    secondary: {
        color: _colors.grey600,
        fontSize: 14
    },
    separator: {
        color: _colors.grey600,
        fontSize: 14,
        fontWeight: 600,
        margin: '0 4px 0 4px'
    },
    timestamp: {
        color: _colors.grey600,
        fontSize: 12,
        marginRight: 8
    }
};
exports.default = (0, _muiThemeable2.default)()(NotificationHeaderArea);
module.exports = exports['default'];